/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "全角数字をハイライト",
  "description": "エラーの原因となる「０」から「９」の全角数字をハイライトして警告します。",
  "credits": [
    {
      "name": "champierre",
      "link": "https://github.com/champierre"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "dynamicDisable": true,
  "tags": [],
  "enabledByDefault": true
};
export default manifest;